import { ContractTaxonomyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'
import HandoffsFormList from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/List'
import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'
import HandoffsItem from 'modules/payroll_bundle/components/Handoffs/Supplements/Item'
import type { EmployeeEstimatedPeriodBaseSalary } from 'modules/payroll_bundle/hooks/useEmployeeEstimatedPeriodBaseSalary'
import { useFrequency } from 'modules/payroll_bundle/lib/frequencyContext'
import { useStatusAuthorizations } from 'modules/payroll_bundle/lib/statusAuthorizationsContext'

interface Params {
  key?: string
  employee: Employee
  estimatedSalary?: EmployeeEstimatedPeriodBaseSalary
  isLast: boolean
}

type Props = Params & {
  supplementsStore: SupplementsFormStore
  loading: boolean
  itemToHighlight?: { employeeId?: number; supplementId?: number } | null
  shouldScrollIntoView?: boolean | null
  taxonomies: ContractTaxonomyFragment[]
  employeeExpansionState?: Record<string, boolean>
  toggleEmployeeExpansion?: (id: string) => void
  toggleTaxonomyCreationModal: (value: boolean) => void
}

const Item = ({
  employee,
  estimatedSalary,
  isLast,
  supplementsStore,
  taxonomies,
  loading,
  itemToHighlight,
  shouldScrollIntoView,
  employeeExpansionState,
  toggleEmployeeExpansion,
  toggleTaxonomyCreationModal,
}: Props) => {
  const { date, frequency } = useFrequency()
  const { supplementPermissions } = useStatusAuthorizations()
  const readonly = !supplementPermissions[employee.attributes.id]?.canEditEmployeeSupplements

  return (
    <HandoffsItem
      store={supplementsStore}
      isLast={isLast}
      employee={employee}
      estimatedSalary={estimatedSalary}
      taxonomies={taxonomies}
      effectiveOn={date}
      loadingSupplements={loading}
      shouldScrollIntoView={shouldScrollIntoView}
      employeeExpansionState={employeeExpansionState}
      toggleEmployeeExpansion={toggleEmployeeExpansion}
      toggleTaxonomyCreationModal={toggleTaxonomyCreationModal}
    >
      {({ isLast, hover }) => (
        <HandoffsFormList
          toggleTaxonomyCreationModal={toggleTaxonomyCreationModal}
          employee={employee}
          effectiveOn={date}
          store={supplementsStore}
          taxonomies={taxonomies}
          itemToHighlight={
            itemToHighlight != null && 'supplementId' in itemToHighlight
              ? (itemToHighlight as { supplementId: number })
              : undefined
          }
          noBorder={isLast}
          readonly={readonly}
          date={date}
          frequency={frequency}
          hover={hover}
        />
      )}
    </HandoffsItem>
  )
}

export default observer(Item)
